import { defineFcm } from '../shared/factory';

export const FCM_ADMIN_USER_SEARCH_OPENSEARCH_DIRECT = defineFcm('admin_user_search_opensearch_direct')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'corgi-middle-end',
		context: 'Admin user search',
		description: 'Use OpenSearch directly for admin user search instead of routing through the search service',
		import: false,
	});
